<template>
  <div class="vx-row mb-12">
    <div
      v-bind:class="[
        detail ? detailShow + 'md:w-1/3 w-full mb-base' : '',
        detailHide,
      ]"
    >
      <vs-table
        search
        stripe
        border
        description
        :sst="true"
        :data="table.data"
        :max-items="table.length"
        :total="table.total"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangelength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>
        <template slot="thead">
          <vs-th>Action</vs-th>
          <vs-th sort-key="code">Advance Invoice</vs-th>
          <vs-th sort-key="supplier_name">Purchase Order</vs-th>
          <vs-th sort-key="warehouse_name">Warehouse</vs-th>
          <vs-th sort-key="due_date">Supplier</vs-th>
          <vs-th sort-key="value">Due Date</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="data"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="data[indextr].class"
          >
            <vs-td>
              <template>
                <vx-tooltip text="Show" style="width: fit-content">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="handleView(tr.payment, indextr)"
                    icon="icon-eye"
                  />
                </vx-tooltip>
              </template>
            </vs-td>
            <vs-td :data="data[indextr].payment.code">
              <div class="flex flex-col gap-1">
                <p>Code : {{ data[indextr].payment.code }}</p>
                <p>External Code : {{ data[indextr].payment.external_code }}</p>
                <p>Date : {{ globalDateFormat(data[indextr].payment.date) }}</p>
                <p>
                  Total Value : {{ priceFormat(data[indextr].payment.value) }}
                </p>
              </div>
            </vs-td>
            <vs-td :data="data[indextr].payment.po_code">
              <div class="flex flex-col gap-1">
                <p>Code : {{ data[indextr].payment.po_code }}</p>
                <p>
                  Date : {{ globalDateFormat(data[indextr].payment.po_date) }}
                </p>
                <p>
                  Total Value :
                  {{ priceFormat(data[indextr].payment.po_total) }}
                </p>
              </div>
            </vs-td>
            <vs-td :data="data[indextr].warehouse.code">
              <div class="flex flex-col gap-1">
                <p>Code : {{ data[indextr].warehouse.code }}</p>
                <p>Name : {{ data[indextr].warehouse.name }}</p>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].payment.partner_code">
              <div class="flex flex-col gap-1">
                <p>Code : {{ data[indextr].payment.partner_code }}</p>
                <p>Name : {{ data[indextr].payment.partner_name }}</p>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].warehouse.code">
              <div class="flex flex-col gap-1">
                <p>{{ globalDateFormat(data[indextr].payment.due_date) }}</p>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        style="padding-top: 5px"
        :total="table.totalPage"
        v-model="setPage"
      />
    </div>
    <!-- form -->
    <transition name="detail-fade">
      <div
        v-if="detail"
        v-bind:class="[
          detail ? detailShow + 'md:w-2/3 w-full mb-base' : '',
          detailHide,
        ]"
      >
        <vs-row>
          <vs-col
            style="padding-bottom: 8px"
            vs-offset="8"
            vs-type="flex"
            vs-justify="rigth"
            vs-align="rigth"
            vs-w="4"
          >
            <vs-button
              class="ml-auto"
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
              >Close</vs-button
            >
          </vs-col>
          <vs-col
            class="vertical-divider"
            vs-offset="0"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="1"
          >
            <vs-button
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
            ></vs-button>
          </vs-col>
          <detail @close="handleClose" :advanceInvoiceID="advanceInvoiceID">
          </detail>
        </vs-row>
      </div>
    </transition>
  </div>
</template>
<script>
import Detail from "./detail.vue";
import moment from "moment";
export default {
  components: {
    Detail,
  },
  data() {
    return {
      detailShow: "core vx-col ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      statusView: false,
      deleteId: null,
      // piId: null,
      // invCode: "",
      // vendor: null,
      // poCode: null,
      // warehouseCode: null,
      // warehouseName: null,
      index1: 0,
      data: [],
      table: {
        data: [],
        length: 5,
        page: 1,
        search: "",
        order: "asc",
        sort: "id",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [5, 10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      },
      activePrompt: false,
      activePromptConfrm: false,
      createdDate: null,
      advanceInvoiceID: 0,
    };
  },
  methods: {
    dateFormat(date) {
      if (date) {
        return moment(String(date)).format("YYYY-MM-DD");
      }
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.detail = false;
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/advance-invoice/data-table", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            // territory_id: this.$userLogin.territory_id,
            // territory_area_id: this.$userLogin.territory_area_id,
            status: 5,
            type: 1,
            is_proposal: true,
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.table.total = resp.data.record_total;
            this.table.totalPage = resp.data.page_total;
            this.table.totalSearch = resp.data.record_total_search;
            this.table.length = resp.data.record_total_per_page;
            this.table.data = resp.data.records;
            this.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleCreate() {
      this.detail = true;
    },
    handleEdit(
      id,
      index,
      poCode,
      vendorCode,
      vendorName,
      invCode,
      warehouseCode,
      warehouseName,
      createdDate,
      data
    ) {
      this.piId = id;
      this.vendor = vendorCode + " - " + vendorName;
      this.poCode = poCode;
      this.createdDate = moment(String(createdDate)).format("DD/MM/YYYY");
      this.invCode = invCode ? invCode : "0";
      this.table.data = [];
      this.table.data = this.data;
      this.warehouseCode = warehouseCode;
      this.warehouseName = warehouseName;
      this.project = data.project;

      this.table.data[this.index1].class = "";
      this.table.data[index].class = "highlight";
      this.detail = true;
      this.index1 = index;
    },

    handleView(tr, index) {
      this.advanceInvoiceID = tr.id;
      this.table.data[this.index1].class = "";
      this.table.data[index].class = "highlight";
      this.detail = true;
      this.index1 = index;
    },
  },
  mounted() {},
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {},
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}

.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
      .core-leave-to
  
      /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

.highlight > td {
  background-color: #d0cdf0;
}
</style>
